import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography, } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAppbar, } from '../../../hooks';
import ScrollableTabsButtonForce from '../ScrollableTabsButtonForce';

export default function AccordionCreate({ beforeDividerMenuPages, afterDividerMenuPages, sx = [], ...props}) {
    const { accordionLibraryIsOpen, accordionLibraryToggle, } = useAppbar();

    return (
        <Accordion
            disableGutters
            elevation={0}
            expanded={accordionLibraryIsOpen}
            onChange={() => accordionLibraryToggle()}
            sx={[...(Array.isArray(sx) ? sx : [sx])]}
            { ...props }>
            <AccordionSummary expandIcon={<ExpandMoreIcon  sx={{ color: 'text.primary', }} />}>
                <Typography sx={{ color: 'text.primary', fontSize: 14, }}>Библиотека</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ borderTop: 1, borderColor: 'borderColor.main', p: 0, }}>
                <ScrollableTabsButtonForce sx={{ minWidth: 200, maxWidth: [250, 450, 600], }} />
            </AccordionDetails>
        </Accordion>
    )
};